exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control-label {\r\n  font-size: small;\r\n}\r\n\r\n.dropdown-menu {\r\n  max-height: 300px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.modal-header {\r\n  color: white;\r\n  background-color: #171514;\r\n}\r\n\r\n.info-fields {\r\n  font-size: small;\r\n}\r\n\r\n.modal-footer {\r\n  background-color: #eeeeee;\r\n}\r\n\r\n.btn {\r\n  border-color: #a3a3a3;\r\n}\r\n\r\n.filter-list {\r\n  background-color: white;\r\n  border: 1px solid #d0d0d0;\r\n  border-radius: 5px;\r\n  height: 320px;\r\n  overflow-y: auto;\r\n  width: -webkit-max-content;\r\n  width: -moz-max-content;\r\n  width: max-content;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.full-width {\r\n  width: 100%;\r\n}\r\n\r\n.selected {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.selected:hover {\r\n  background-color: #dadada;;\r\n}\r\n\r\n.td-name {\r\n  width: 80%;\r\n  padding-left: 15px;\r\n}\r\n\r\n.td-name:hover {\r\n  background-color: #f7f7f7;\r\n  cursor: pointer;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-standard-head/modal/add-standard-type/add-standard-type.component.css
// module id = ../../../../../src/app/content-page/admin/create-standard-head/modal/add-standard-type/add-standard-type.component.css
// module chunks = main